import type { ComponentType } from "react";
import { Navigate } from "react-router-dom";
import ContratsPage from "../pages/clients/ContratPage";
import PortailClientAdminPage from "../pages/client-portal-admin/PortailClientAdminPage";
import PlanificateurDashboard from "../pages/planification-logistique/planificateur/PlanificateurDashboard";
import InterventionsPage from "../pages/terrain-supervision/chef/InterventionsPage";
import CarteZonePage from "../pages/CarteZonePage";
import HistoriquePassagesPage from "../pages/planification-logistique/passages/HistoriquePassagesPage";
import AdminAuditOperationalPage from "../pages/admin/AdminAuditOperationalPage";
import AdminBusinessEventsPage from "../pages/admin/AdminBusinessEventsPage";
import AdminPdfJobsPage from "../pages/admin/AdminPdfJobsPage";
import TerrainCartePage from "../pages/planification-logistique/terrain/TerrainCartePage";
import FactureDetailStubPage from "../pages/placeholders/FactureDetailStubPage";
import FinanceFacturesPage from "../pages/finance-recouvrement/finance/FinanceFacturesPage";
import FinancePaiementsPage from "../pages/finance-recouvrement/finance/FinancePaiementsPage";
import FinanceRecouvrementPage from "../pages/finance-recouvrement/finance/FinanceRecouvrementPage";
import FinanceProformasPage from "../pages/finance-recouvrement/finance/FinanceProformasPage";
import FinanceQuittancesPage from "../pages/finance-recouvrement/finance/FinanceQuittancesPage";
import CloturesFinancieresPage from "../pages/finance/CloturesFinancieresPage";
import NouvelleFacture from "../pages/finance-recouvrement/finance/NouvelleFacture";
import NewProforma from "../pages/Proformas/NewProforma";
import ProformaDetailPage from "../pages/Proformas/ProformaDetailPage";
import ListeEmployesRHPage from "../pages/rh-employes/ListeEmployesRHPage";
import NouveauEmployeRHPage from "../pages/rh-employes/NouveauEmployeRHPage";
import EmployeRHDetailPage from "../pages/rh-employes/EmployeRHDetailPage";
import OrganisationTerrainPage from "../pages/organisation-terrain/OrganisationTerrainPage";
import RessourcesOperationnellesPage from "../pages/ressources/RessourcesOperationnellesPage";
import ResourceCatalogPage from "../pages/resources/ResourceCatalogPage";
import ResourceMovementsPage from "../pages/resources/ResourceMovementsPage";
import AdminCharroiVehiculesRedirect from "../pages/placeholders/AdminCharroiVehiculesRedirect";
import EquipeDetailPage from "../pages/equipes/EquipeDetailPage";
import EquipesAdminPage from "../pages/equipes/EquipesAdminPage";
import ParametresPage from "../pages/admin-securite/Parametres/ParametresPage";
import ZonesOperationnellesPage from "../pages/planification-logistique/planificateur/ZonesOperationnellesPage";
import ZoneDetailPage from "../pages/planification-logistique/planificateur/ZoneDetailPage";
import GeographieReferentielPage from "../pages/planification-logistique/planificateur/GeographieReferentielPage";
import NouvelleDescenteLegacyRedirect from "../pages/planification-logistique/planificateur/NouvelleDescenteLegacyRedirect";
import PassageUrgencePage from "../pages/planification-logistique/passages/PassageUrgencePage";
import PlanningPassagesPage from "../pages/planification-logistique/planificateur/PlanningPassagesPage";
import TourneesPage from "../pages/planification-logistique/planificateur/TourneesPage";
import TourneeDetailPage from "../pages/planification-logistique/planificateur/TourneeDetailPage";
import TourneesAnalyticsPage from "../pages/planification-logistique/planificateur/TourneesAnalyticsPage";
import TourneeExecutionPage from "../pages/planification-logistique/execution/TourneeExecutionPage";
import Envoyees from "../pages/planification-logistique/planificateur/Envoyees";
import PointsParDescente from "../pages/planification-logistique/planificateur/PointsParDescente";
import FicheView from "../pages/planification-logistique/planificateur/FicheView";
import ArchivesPage from "../pages/planification-logistique/planificateur/ArchivesPage";
import PointsEdit from "../pages/planification-logistique/planificateur/PointsEdit";
import PlansAbonnementPage from "../pages/admin-securite/Parametres/CategoriesTarifs";
import DocumentsCommerciauxPage from "../pages/admin-securite/Parametres/DocumentsCommerciauxPage";
import AdminClientRequestsPage from "../modules/admin/client-requests/AdminClientRequestsPage";
import AdminE2EDebugPage from "../pages/admin/AdminE2EDebugPage";

export type AdminMirroredRoute = {
  path: string;
  Element: ComponentType;
};

/** Routes clients gérées dans `App.tsx` (arbre imbriqué), exclues de la liste plate. */
export const ADMIN_CLIENT_ROUTE_PATHS = new Set([
  "clients",
  "clients/reclamations",
  "clients/nouveau",
  "clients/:id",
]);

function RedirectOrganisationTerrain() {
  return <Navigate to="/admin/organisation-terrain" replace />;
}

function RedirectContrats() {
  return <Navigate to="/admin/contrats" replace />;
}

function RedirectCategoriesTarifs() {
  return <Navigate to="/admin/categories-tarifs" replace />;
}

function RedirectExecutionPassages() {
  return <Navigate to="/admin/execution-passages" replace />;
}

function RedirectHistoriquePassages() {
  return <Navigate to="/admin/historique-passages" replace />;
}

function RedirectPortailClientAlias() {
  return <Navigate to="/admin/portail-client" replace />;
}

function RedirectRecouvrementAjouter() {
  return <Navigate to="/admin/finance/recouvrement" replace />;
}

function RedirectZonesOperationnellesAlias() {
  return <Navigate to="/admin/zones" replace />;
}

/** Même pages métier que sous Layout, préfixe URL `/admin/...` pour la navigation admin. */
export const ADMIN_MIRRORED_ROUTES: AdminMirroredRoute[] = [
  { path: "finance/factures/nouvelle", Element: NouvelleFacture },
  { path: "finance/factures/:id", Element: FactureDetailStubPage },
  { path: "finance/factures", Element: FinanceFacturesPage },
  { path: "finance/paiements", Element: FinancePaiementsPage },
  { path: "finance/recouvrement", Element: FinanceRecouvrementPage },
  { path: "finance/proformas/nouvelle", Element: NewProforma },
  { path: "finance/proformas/:id", Element: ProformaDetailPage },
  { path: "finance/proformas", Element: FinanceProformasPage },
  { path: "finance/quittances", Element: FinanceQuittancesPage },
  { path: "finance/clotures", Element: CloturesFinancieresPage },
  { path: "demandes-client", Element: AdminClientRequestsPage },
  { path: "contrats", Element: ContratsPage },
  { path: "abonnements", Element: RedirectContrats },
  { path: "plans-abonnement", Element: RedirectCategoriesTarifs },
  { path: "categories-tarifs", Element: PlansAbonnementPage },
  { path: "espace-client-info", Element: RedirectPortailClientAlias },
  { path: "portail-client", Element: PortailClientAdminPage },
  { path: "planificateur/descentes/:id/points/edit", Element: PointsEdit },
  { path: "planificateur/points-edit", Element: PointsEdit },
  { path: "planificateur/fiche/:id", Element: FicheView },
  { path: "planificateur/points/:id", Element: PointsParDescente },
  { path: "planificateur/archives", Element: ArchivesPage },
  { path: "planificateur/envoyees", Element: Envoyees },
  { path: "planificateur/passages", Element: PlanningPassagesPage },
  { path: "passages/urgence", Element: PassageUrgencePage },
  { path: "passages/historique", Element: HistoriquePassagesPage },
  { path: "passages", Element: PlanningPassagesPage },
  { path: "historique-passages", Element: HistoriquePassagesPage },
  { path: "audit-operational", Element: AdminAuditOperationalPage },
  { path: "business-events", Element: AdminBusinessEventsPage },
  { path: "system/pdf-jobs", Element: AdminPdfJobsPage },
  { path: "debug/e2e", Element: AdminE2EDebugPage },
  { path: "terrain/carte", Element: TerrainCartePage },
  { path: "carte-terrain", Element: TerrainCartePage },
  { path: "planificateur/tournees", Element: TourneesPage },
  { path: "planificateur/tournees/:id", Element: TourneeDetailPage },
  { path: "execution/tournees/:id", Element: TourneeExecutionPage },
  { path: "tournees/analytics", Element: TourneesAnalyticsPage },
  { path: "tournees", Element: TourneesPage },
  { path: "planificateur", Element: PlanificateurDashboard },
  { path: "execution-passages", Element: InterventionsPage },
  { path: "interventions", Element: RedirectExecutionPassages },
  { path: "planificateur/historique", Element: RedirectHistoriquePassages },
  { path: "map/:zone", Element: CarteZonePage },
  { path: "paiements", Element: FinancePaiementsPage },
  { path: "recouvrement", Element: FinanceRecouvrementPage },
  { path: "rh/employes/nouveau", Element: NouveauEmployeRHPage },
  { path: "rh/employes/:id", Element: EmployeRHDetailPage },
  { path: "rh/employes", Element: ListeEmployesRHPage },
  { path: "organisation-terrain", Element: OrganisationTerrainPage },
  { path: "ressources-operationnelles", Element: RessourcesOperationnellesPage },
  { path: "ressources/catalogue", Element: ResourceCatalogPage },
  { path: "ressources/mouvements", Element: ResourceMovementsPage },
  { path: "charroi/vehicules", Element: AdminCharroiVehiculesRedirect },
  { path: "planificateur/repartition", Element: RedirectOrganisationTerrain },
  { path: "equipes", Element: EquipesAdminPage },
  { path: "equipes/:id", Element: EquipeDetailPage },
  { path: "zones/:id", Element: ZoneDetailPage },
  { path: "zones", Element: ZonesOperationnellesPage },
  { path: "geographie", Element: GeographieReferentielPage },
  { path: "zones-operationnelles", Element: RedirectZonesOperationnellesAlias },
  { path: "parametres/documents-commerciaux", Element: DocumentsCommerciauxPage },
  { path: "parametres/plans-abonnement", Element: PlansAbonnementPage },
  { path: "parametres", Element: ParametresPage },
  { path: "planificateur/nouvelle-descente", Element: NouvelleDescenteLegacyRedirect },
  { path: "recouvrement/ajouter", Element: RedirectRecouvrementAjouter },
];
